/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

/* eslint-disable no-console */
import React, { ComponentType, RefObject } from 'react';
import { IHeaderContainerComponentProps } from '../types/tableVisualizationTypes';
import TableHeaderRowComponentHOC, { ITableHeaderRowComponentProps } from './TableHeaderRowComponent';
import { TableCellComponent } from './TableCellComponent';

export function HeaderContainerComponentHOC(Row: ComponentType<ITableHeaderRowComponentProps>) {
    return function HeaderContainerComponent(props: IHeaderContainerComponentProps) {

        const {
            getRef, header, linkOptions, linkToRefObjectPairs
        } = props;
        const { cells } = header;

        const ref: RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

        getRef(ref);

        return (
            <div
                ref={ref}
                className="jr-mDatatable-headerContainer jr"
                style={{ overflow: 'hidden' }}
            >
                <table
                    className="jr-mDatatable jr"
                    unselectable="on"
                    js-stdnav="true"
                    js-navtype="table"
                    aria-label="Table. Use Alt and direction arrow keys for pagination"
                >
                    <thead className="jr-mDatatable-header jr">
                        <Row
                            linkToElemPairs={linkToRefObjectPairs}
                            row={{ cells }}
                            linkOptions={linkOptions}
                        />
                    </thead>
                </table>
            </div>
        );
    }
}

const Row = TableHeaderRowComponentHOC(TableCellComponent);
export const HeaderContainerComponent = HeaderContainerComponentHOC(Row);
